export { MatchScoreBreakdown, isSkillsExcluded } from './MatchScoreBreakdown';
export type { MatchScoreBreakdownProps } from './MatchScoreBreakdown';
